import CARE_SERVICE_TYPE from './care-service-type';

const BASIC_CARE_SERVICE = CARE_SERVICE_TYPE.filter(_ => _.type !== 0).map(_ => _.directive);

type BASIC_CARE_SERVICE = typeof BASIC_CARE_SERVICE;

export default BASIC_CARE_SERVICE;
